import type { IconProps } from '.';

/**
 * Lock Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const LockIcon = ({ className, 'aria-label': ariaLabel }: IconProps) => (
  <svg
    role="img"
    aria-label={ariaLabel}
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 10V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V10H18V18H6V10H9ZM14 7V10H10V7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7ZM7 11V17H17V11H7Z"
      fill="white"
    />
  </svg>
);

export default LockIcon;
